var _path, _path2, _rect, _path3, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOccupation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99731 5.33333C9.99731 4.59695 10.5943 4 11.3306 4H16.664C17.4004 4 17.9973 4.59695 17.9973 5.33333V8H9.99731V5.33333Z",
    fill: "#37383A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9973 6.66667C11.9973 6.29848 12.2958 6 12.664 6H15.3306C15.6988 6 15.9973 6.29848 15.9973 6.66667V8H11.9973V6.66667Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33069,
    y: 8,
    width: 21.3333,
    height: 16,
    rx: 2.66667,
    fill: "#37383A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.664 14.6982C21.2488 15.5486 17.6758 16 13.9974 16C10.3189 16 6.7459 15.5486 3.33069 14.6982V10.6667C3.33069 9.19391 4.5246 8 5.99736 8H21.9974C23.4701 8 24.664 9.19391 24.664 10.6667V14.6982Z",
    fill: "#ADADAD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.664,
    y: 13,
    width: 3.33333,
    height: 4.66667,
    rx: 1.66667,
    fill: "white",
    stroke: "#37383A",
    strokeWidth: 0.666667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99736,
    y: 13,
    width: 3.33333,
    height: 4.66667,
    rx: 1.66667,
    fill: "white",
    stroke: "#37383A",
    strokeWidth: 0.666667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupation);
export default __webpack_public_path__ + "static/media/Occupation.4915ad1584f8a9a75dd893059388defb.svg";
export { ForwardRef as ReactComponent };